import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Button, Label } from 'semantic-ui-react';

import ContentSuggestionsModal from 'components/modules/content/components/ContentSuggestionsModal';
import { getOriginalContent } from 'components/modules/content/components/PageContentNode/PageContentNode.utils';
import { ContentSuggestionType, ContentNodeType } from 'components/modules/content/types';

const propTypes = {
  suggestions: PropTypes.arrayOf(ContentSuggestionType).isRequired,
  contentNode: ContentNodeType.isRequired,
  onReviewSuggestions: PropTypes.func.isRequired,
};

export default function SuggestionsButton({ suggestions, contentNode, onReviewSuggestions }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  function onToggleModal() {
    setIsModalOpen((prev) => !prev);
  }

  function handleClose() {
    setIsModalOpen(false);
  }

  async function handleSave() {
    await onReviewSuggestions();
    setIsModalOpen(false);
  }

  return (
    <>
      <Button primary basic size="tiny" onClick={onToggleModal}>
        Suggestions
        <Label color="red" floating circular>
          {suggestions.length}
        </Label>
      </Button>
      <ContentSuggestionsModal
        suggestionSets={[
          {
            originalContent: getOriginalContent(contentNode),
            suggestions,
          },
        ]}
        onSave={handleSave}
        onClose={handleClose}
        open={isModalOpen}
      />
    </>
  );
}

SuggestionsButton.propTypes = propTypes;
